import {
    Blackjack2DecisionType,
    Blackjack2GameState,
    Blackjack2RecordState,
    Blackjack2WinState,
} from '.';

export type CardInfo = {
    cards: Array<number>;
    display_txt: string;
    last_decision: Blackjack2DecisionType;
    allow_decision: Array<Blackjack2DecisionType>;
    result?: Blackjack2WinState; //win,lose,push
    recordState?: Blackjack2RecordState;
};

export type CardSeatInfo = {
    isSplit: boolean;
    hand1: CardInfo;
    hand2: CardInfo;
};
export type HandSeats = {
    HostId: number;
    GameState: Blackjack2GameState;
    ActionSeat: number;
    ActionHand: number;
    Dealer: CardInfo;
    Seat1: CardSeatInfo;
    Seat2: CardSeatInfo;
    Seat3: CardSeatInfo;
    Seat4: CardSeatInfo;
    Seat5: CardSeatInfo;
    Seat6: CardSeatInfo;
    Seat7: CardSeatInfo;
};

export const getEmptyHandsInfo = () => ({
    cards: [],
    display_txt: '',
    last_decision: 0,
    allow_decision: [],
});

export const getEmptySeatHandsInfo = () => ({
    isSplit: false,
    hand1: getEmptyHandsInfo(),
    hand2: getEmptyHandsInfo(),
});

export const getNewBetHands = (hostId: number): HandSeats => ({
    HostId: hostId,
    GameState: 0,
    ActionSeat: -1,
    ActionHand: 0,
    Dealer: getEmptyHandsInfo(),
    Seat1: getEmptySeatHandsInfo(),
    Seat2: getEmptySeatHandsInfo(),
    Seat3: getEmptySeatHandsInfo(),
    Seat4: getEmptySeatHandsInfo(),
    Seat5: getEmptySeatHandsInfo(),
    Seat6: getEmptySeatHandsInfo(),
    Seat7: getEmptySeatHandsInfo(),
});
